import $ from 'jquery';

//Get Use Cookie Setting
try {
	const IsUseCookie = IsUseCookie;
} catch {
	const IsUseCookie = undefined;
}
export const siteIsUseCookie = IsUseCookie;

/* 正規表示式-移除所有空白字元及符號("\s", "\w", "\W", "\b")
 *
 * Author: Victor Chen
 * Date: 2007/05/06
 * Update Author: Victor Chen
 * Update 2007/05/06
 */
export function trim(strValue) {
    "use strict"
    var objRegExp = /^(\s*)$/;
    if (objRegExp.test(strValue)) {
        strValue = strValue.replace(objRegExp, '');
        if (strValue.length == 0)
            return strValue;
    }
    objRegExp = /^(\s*)([\W\w]*)(\b\s*$)/;
    if (objRegExp.test(strValue)) {
        strValue = strValue.replace(objRegExp, '$2');
    }
    return strValue;
}

// Check Email Fromat
//Author : Brian Yang  (Copy from Google)
//Date : 2007/10/17
//
export function emailCheck(emailStr) {
    "use strict"
    /* The following pattern is used to check if the entered e-mail address
      fits the user@domain format.  It also is used to separate the username
      from the domain. */
    var emailPat = /^(.+)@(.+)$/
    /* The following string represents the pattern for matching all special
      characters.  We don't want to allow special characters in the address.
      These characters include ( ) < > @ , ; : \ " . [ ]    */
    var specialChars = "\\(\\)<>@,;:\\\\\\\"\\.\\[\\]"
    /* The following string represents the range of characters allowed in a
      username or domainname.  It really states which chars aren't allowed. */
    var validChars = "\[^\\s" + specialChars + "\]"
    /* The following pattern applies if the "user" is a quoted string (in
      which case, there are no rules about which characters are allowed
      and which aren't; anything goes).  E.g. "jiminy cricket"@disney.com
      is a legal e-mail address. */
    var quotedUser = "(\"[^\"]*\")"
    /* The following pattern applies for domains that are IP addresses,
      rather than symbolic names.  E.g. joe@[123.124.233.4] is a legal
      e-mail address. NOTE: The square brackets are required. */
    var ipDomainPat = /^\[(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})\]$/
    /* The following string represents an atom (basically a series of
      non-special characters.) */
    var atom = validChars + '+'
    /* The following string represents one word in the typical username.
      For example, in john.doe@somewhere.com, john and doe are words.
      Basically, a word is either an atom or quoted string. */
    var word = "(" + atom + "|" + quotedUser + ")"
    // The following pattern describes the structure of the user
    var userPat = new RegExp("^" + word + "(\\." + word + ")*$")
    /* The following pattern describes the structure of a normal symbolic
      domain, as opposed to ipDomainPat, shown above. */
    var domainPat = new RegExp("^" + atom + "(\\." + atom + ")*$")


    /* Finally, let's start trying to figure out if the supplied address is
      valid. */

    /* Begin with the coarse pattern to simply break up user@domain into
      different pieces that are easy to analyze. */
    var matchArray = emailStr.match(emailPat)
    if (matchArray == null) {
        /* Too many/few @'s or something; basically, this address doesn't
           even fit the general mould of a valid e-mail address. */
        //alert("Email address seems incorrect (check @ and .'s)")
        return false
    }
    var user = matchArray[1]
    var domain = matchArray[2]

    // See if "user" is valid
    if (user.match(userPat) == null) {
        // user is not valid
        //alert("The username doesn't seem to be valid.")
        return false
    }

    /* if the e-mail address is at an IP address (as opposed to a symbolic
      host name) make sure the IP address is valid. */
    var IPArray = domain.match(ipDomainPat)
    if (IPArray != null) {
        // this is an IP address
        for (var i = 1; i <= 4; i++) {
            if (IPArray[i] > 255) {
                //alert("Destination IP address is invalid!")
                return false
            }
        }
        return true
    }

    // Domain is symbolic name
    var domainArray = domain.match(domainPat)
    if (domainArray == null) {
        //alert("The domain name doesn't seem to be valid.")
        return false
    }

    /* domain name seems valid, but now make sure that it ends in a
      three-letter word (like com, edu, gov) or a two-letter word,
      representing country (uk, nl), and that there's a hostname preceding
      the domain or country. */

    /* Now we need to break up the domain to get a count of how many atoms
      it consists of. */
    var atomPat = new RegExp(atom, "g")
    var domArr = domain.match(atomPat)
    var len = domArr.length
    if (domArr[domArr.length - 1].length < 2 ||
       domArr[domArr.length - 1].length > 4) {
        // the address must end in a two letter or three letter word.
        //alert("The address must end in a three-letter domain, or two letter country.")
        return false
    }

    // Make sure there's a host name preceding the domain.
    if (len < 2) {
        var errStr = "This address is missing a hostname!"
        //alert(errStr)
        return false
    }
    var validChinese=/[\u4e00-\u9fa5]+/g
    if (validChinese.test(emailStr))
    {
       return false;
    }
    // If we've gotten this far, everything's valid!
    return true;
}

export function zipCodeCheck(zipCode) {
    return /^[a-zA-Z0-9\s]{1,}$/.test(zipCode);
}

export const MD5 = function (string) {
    "use strict"
    function RotateLeft(lValue, iShiftBits) {
        return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
    }

    function AddUnsigned(lX, lY) {
        var lX4, lY4, lX8, lY8, lResult;
        lX8 = (lX & 0x80000000);
        lY8 = (lY & 0x80000000);
        lX4 = (lX & 0x40000000);
        lY4 = (lY & 0x40000000);
        lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
        if (lX4 & lY4) {
            return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
        }
        if (lX4 | lY4) {
            if (lResult & 0x40000000) {
                return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
            } else {
                return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
            }
        } else {
            return (lResult ^ lX8 ^ lY8);
        }
    }

    function F(x, y, z) { return (x & y) | ((~x) & z); }
    function G(x, y, z) { return (x & z) | (y & (~z)); }
    function H(x, y, z) { return (x ^ y ^ z); }
    function I(x, y, z) { return (y ^ (x | (~z))); }

    function FF(a, b, c, d, x, s, ac) {
        a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
        return AddUnsigned(RotateLeft(a, s), b);
    };

    function GG(a, b, c, d, x, s, ac) {
        a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
        return AddUnsigned(RotateLeft(a, s), b);
    };

    function HH(a, b, c, d, x, s, ac) {
        a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
        return AddUnsigned(RotateLeft(a, s), b);
    };

    function II(a, b, c, d, x, s, ac) {
        a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
        return AddUnsigned(RotateLeft(a, s), b);
    };

    function ConvertToWordArray(string) {
        var lWordCount;
        var lMessageLength = string.length;
        var lNumberOfWords_temp1 = lMessageLength + 8;
        var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
        var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
        var lWordArray = Array(lNumberOfWords - 1);
        var lBytePosition = 0;
        var lByteCount = 0;
        while (lByteCount < lMessageLength) {
            lWordCount = (lByteCount - (lByteCount % 4)) / 4;
            lBytePosition = (lByteCount % 4) * 8;
            lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
            lByteCount++;
        }
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
        lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
        return lWordArray;
    };
    /*
       function WordToHex(lValue) {
           var WordToHexValue="",WordToHexValue_temp="",lByte,lCount;
           for (lCount = 0;lCount<=3;lCount++) {
               lByte = (lValue>>>(lCount*8)) & 255;
               WordToHexValue_temp = "0" + lByte.toString(16);
               WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length-2,2);
           }
           return WordToHexValue;
       };
    */
    function Utf8Encode(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    };

    var x = Array();
    var k, AA, BB, CC, DD, a, b, c, d;
    var S11 = 7, S12 = 12, S13 = 17, S14 = 22;
    var S21 = 5, S22 = 9, S23 = 14, S24 = 20;
    var S31 = 4, S32 = 11, S33 = 16, S34 = 23;
    var S41 = 6, S42 = 10, S43 = 15, S44 = 21;

    string = Utf8Encode(string);

    x = ConvertToWordArray(string);

    a = 0x67452301; b = 0xEFCDAB89; c = 0x98BADCFE; d = 0x10325476;

    function WordToHex(lValue) {
        var WordToHexValue = "", WordToHexValue_temp = "", lByte, lCount;
        for (lCount = 0; lCount <= 3; lCount++) {
            lByte = (lValue >>> (lCount * 8)) & 255;
            WordToHexValue_temp = "0" + lByte.toString(16);
            WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
        }
        return WordToHexValue;
    };

    for (k = 0; k < x.length; k += 16) {
        AA = a; BB = b; CC = c; DD = d;
        a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
        d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
        c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
        b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
        a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
        d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
        c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
        b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
        a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
        d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
        c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
        b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
        a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
        d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
        c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
        b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
        a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
        d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
        c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
        b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
        a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
        d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
        c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
        b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
        a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
        d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
        c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
        b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
        a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
        d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
        c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
        b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
        a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
        d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
        c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
        b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
        a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
        d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
        c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
        b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
        a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
        d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
        c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
        b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
        a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
        d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
        c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
        b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
        a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
        d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
        c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
        b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
        a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
        d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
        c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
        b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
        a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
        d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
        c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
        b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
        a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
        d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
        c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
        b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
        a = AddUnsigned(a, AA);
        b = AddUnsigned(b, BB);
        c = AddUnsigned(c, CC);
        d = AddUnsigned(d, DD);
    }

    var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);

    return temp.toLowerCase();
}

export const CFS = function (codeStr) {
    "use strict"
    function CfsCode(nWord) {
        var result = "";
        for (var cc = 1; cc <= nWord.length; cc++) {
            result += nWord.charAt(cc - 1).charCodeAt(0);
        }
        var DecimalValue = new Number(result);
        result = DecimalValue.toString(16);
        return result;
    };

    var CodeLen = 30, CodeSpace, Been;
    CodeSpace = CodeLen - codeStr.length;
    if (CodeSpace > 1) {
        for (var cecr = 1; cecr <= CodeSpace; cecr++) {
            codeStr = codeStr + String.fromCharCode(21);
        }
    }
    var NewCode = new Number(1);

    for (var cecb = 1; cecb <= CodeLen; cecb++) {
        Been = CodeLen + codeStr.charAt(cecb - 1).charCodeAt(0) * cecb;
        NewCode = NewCode * Been;
    }

    var tmpNewCode = new Number(NewCode.toPrecision(15));	//to convert to the same precision as c# code
    codeStr = tmpNewCode.toString().toUpperCase();
    var NewCode2 = "";

    for (var cec = 1; cec <= codeStr.length; cec++) {
        NewCode2 = NewCode2 + CfsCode(codeStr.substring(cec - 1, cec + 2));
    }

    var CfsEncodeStr = "";
    for (var cec = 20; cec <= NewCode2.length - 18; cec += 2) {
        CfsEncodeStr = CfsEncodeStr + NewCode2.charAt(cec - 1);
    }
    return CfsEncodeStr.toUpperCase();
}

export function userBrowser() {
    "use strict"
    var browserName = navigator.userAgent.toLowerCase();
    if (/msie/i.test(browserName) && !/opera/.test(browserName)) {
        return "IE";
    } else if (/firefox/i.test(browserName)) {
        return "Firefox";
    } else if (/chrome/i.test(browserName) && /webkit/i.test(browserName) && /mozilla/i.test(browserName)) {
        return "Chrome";
    } else if (/opera/i.test(browserName)) {
        return "Opera";
    } else if (/webkit/i.test(browserName) && !(/chrome/i.test(browserName) && /webkit/i.test(browserName) && /mozilla/i.test(browserName))) {
        return "Safari";
    } else {
        return "unKnow";
    }
}

export function GetQueryString(name, qurstring) {
    "use strict"
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    if (!qurstring) {
        qurstring = window.location.search.substr(1);
    }
    var r = qurstring.match(reg);
    var context = "";
    if (r != null)
        context = r[2];
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
}

export function RemoveQueryString(name, qurstring) {
    "use strict"
    if (!qurstring) {
        qurstring = window.location.search.substr(1);
    }
    var r = name + "=" + GetQueryString(name.toLowerCase(), qurstring.toLowerCase());
    var context = "";
    context = qurstring.toLowerCase().replace("&" + r, "");
    context = context.replace(r, "");
    return context === null || context === "" || context === "undefined" ? "" : context.toLowerCase();
}


export function AddQueryString(val, qurstring) {
    "use strict"
    if (!qurstring && qurstring!=="") {
        qurstring = window.location.search.substr(1);
    }
    
    var context = "";
    context = qurstring + (qurstring === "" ? "" : "&") + val;
    return context === null || context === "" || context === "undefined" ? "" : context.toLowerCase();
}

export function toOneElementArray(element) {
    "use strict"
    return [element];
}

export const checkMobileAgent = function() {
	const userAgentInfo = navigator.userAgent;
	let flag = false;
	if (userAgentInfo.match(/Android|iPhone|iPad|iPod/i)) {
		flag = true;
	}

	return flag;
};

export const createCustomEvent = (eventName, data) => {
    let event;
    if(typeof Event === 'function') {
        // for modern browser
        event = new CustomEvent(eventName, {
            'detail': data
        });
    } else {
        // for IE
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, data);
    }

    return event;
};



export async function GetConfig(url, method, data) {
    method = method == null ? 'GET' : 'POST';
	const request = new Request(getFullUrlPath(url), {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        method: method,
		headers: new Headers({
			pragma: 'no-cache',
            'cache-control': 'no-cache',
            'content-type': 'application/json'
		})
	});
	const response = await fetch(request);
	if (!response.ok) {
		throw new Error(response.statusText);
	}

	return await response.json();
};

export const isMoneyFormat = (id, usepoint) => {
    let tmp;
    const z = '0123456789';
    var str1 = id.charAt(0); 
    if (str1 == '.' || str1 =='0')
    {
        return false;
    }
    
    const point = id.length - 3;
    if(usepoint) {
        let haspoint = false;
        for (let i = 0; i < id.length; i++) {
            tmp = id.substr(i, 1);
            if (z.indexOf(tmp) === -1 && !(i >= point && '.'.indexOf(tmp) === 0 && !haspoint)) {
                return false;
            }
            haspoint = haspoint || ('.'.indexOf(tmp) === 0);
        }
    }
    else {
        for (let i = 0; i < id.length; i++) {
            tmp = id.substr(i, 1);
            if (z.indexOf(tmp) === -1) {
                return false;
            }
        }
    }
    return true;
};

export const isNumberFormat = id => {
    let tmp;
    const z = '0123456789';
    for (let i = 0; i < id.length; i++) {
        tmp = id.substr(i, 1);
        if (z.indexOf(tmp) === -1) {
            return false;
        }
    }
    return true;
};

export function numberCheck(number) {
    return /^[\d]{1,}$/.test(number);
}

export function passwordCheck(password) {
    return /^[a-zA-Z0-9]{6,10}$/.test(password);
}

export function phoneCheck(phone) {
    return /^[\+\-\d]{1,}$/.test(phone);
}


export const isPhoneFormat = id => {
    let tmp;
    const z = '0123456789+-';
    for (let i = 0; i < id.length; i++) {
        tmp = id.substr(i, 1);
        if (z.indexOf(tmp) === -1) {
            return false;
        }
    }
    return true;
}

/*
if ((1.1).toLocaleString().indexOf(".") >= 0) {
    return this.toString().split( /(?=(?:\d{3})+(?:\.|$))/g ).join( "," );
}
else {
    return this.toString().split( /(?=(?:\d{3})+(?:,|$))/g ).join( "." );
}*/

export function addCommas(strValue, haspoint, pointCount) {
    let objRegExp = new RegExp('(-?[0-9]+)([0-9]{3})');
    if(strValue === null || strValue === undefined) {
        return '';
    }
    strValue = (strValue).toString();
    if(haspoint) {
        if(strValue.indexOf(".") < 0) {
            strValue = strValue + ".00";
        }
        else if (strValue.indexOf(".") === strValue.length-1){
            strValue = strValue + "00";
        }
        else if (strValue.indexOf(".") === strValue.length-2){
            strValue = strValue + "0";
        }
        if(pointCount) {
            var strpoint = strValue.substr(strValue.indexOf("."), pointCount + 1);
            strValue = strValue.substr(0, strValue.indexOf(".")) + ''+ strpoint;
        }
    }
    else {
        if(strValue.indexOf(".") !== -1) {
            strValue = Math.round(strValue);
        } 
    }
    while (objRegExp.test(strValue)) {
        if (!isNaN(strValue)) {
            strValue = strValue.toString();
        }
        strValue = strValue.replace(objRegExp, '$1,$2');
    }
    return strValue;
}


export function isEmpty(e) {
    return e && Object.keys(e).length === 0;
}

export function objectToQueryString(object = {}) {
    return Object.entries(object).reduce((searchParams, [key, value]) => {
        searchParams.append(key, value);
        return searchParams;
    }, new URLSearchParams()).toString();
}

export function objectToWindowFeaturesString(object = {}) {
    return Object.entries(object).map(entry => `${entry[0]}=${entry[1]}`).join(',');
}

export function formatDT(strValue, showtime) {
    let date = new Date(strValue);
    let val = ('0'+ (date.getMonth() + 1)).substr(-2) + '/' + ('0'+ date.getDate()).substr(-2) + '/' +  date.getFullYear();
    if(showtime) {
        val += " ";
        val += ('0'+ date.getHours()).substr(-2) + ":" + ('0'+ date.getMinutes()).substr(-2);
    }
    return val;
};

export function removeCommas(strValue) {
    let objRegExp = /,/g;
    return strValue.replace(objRegExp, '');
};

export function formatDateTime(date, hasYear) {
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
        days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    return (months[date.getMonth()] + ' ' + date.getDate() + (hasYear ? (', ' + date.getFullYear()) : ''));
}

export function setToKafka(type, action, note) {
    const data = { type, action, note };
    const url = 'Kafka/AddKafkaResult';
    $.ajax(getFullUrlPath(url), {
        type: 'POST',
        data: data,
        async: true,
        cache: false,
        success: () => { },
        error: console.error
    });
}

export function getFullUrlPath(targetPath) {
    let baseUrl = window.location.origin;
    if (!siteIsUseCookie) {
        const pathName = window.location.pathname;
        let sessionKey = pathName.split('/')[1];
        baseUrl += `/${sessionKey}`;
    }
    return baseUrl + '/' + targetPath;
}